import React, { useRef, useEffect, useState } from 'react';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import { servicesData } from '../../data/servicesData';

import './Services.css'
import SingleService from './SingleService/SingleService';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';

function Services() {
  const sliderRef = useRef(null);
  const [slidesToShow, setSlidesToShow] = useState(6);
  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={className} style={style} onClick={onClick}>
        <div className="next-slick-arrow"><FaArrowRight size={24}/></div>
      </div>
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={className} style={style} onClick={onClick}>
        <div className="prev-slick-arrow"><FaArrowLeft size={24}/></div>
      </div>
    );
  }

  const getResponsiveSettings = () => {
    if (window.innerWidth <= 600) {
      return 1;
    } else if (window.innerWidth <= 1100) {
      return 3;
    }
    return 6;
  };

  const updateSlidesToShow = () => {
    setSlidesToShow(getResponsiveSettings());
  };

    var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  useEffect(() => {
    // Set initial slides to show based on window size
    updateSlidesToShow();

    // Recalculate on resize
    const handleResize = () => {
      updateSlidesToShow();
    };

    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);
    // const { theme } = useContext(ThemeContext);
    return (
        <>
            {servicesData.length > 0 && (
                <div className="services" id="services" /*style={{backgroundColor:theme.secondary}}*/>
                    <div className="services-body">
                        <div className="services-bodycontainer">
                            <Slider ref={sliderRef} {...settings}>
                                {servicesData.map(services => (
                                    <SingleService
                                    key={services.id}
                                    id={services.id}
                                    title={services.title}
                                    icon={services.icon}/>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            )}
       </>
    )
}

export default Services
